export default __webpack_public_path__ + "static/logo_name-88efcdcc94ae9928b62ae8889d305336.svg";